import axios, { AxiosResponse } from "axios";
import { setupInterceptorsTo } from "../api/Interceptors";


export const axiosInstance = setupInterceptorsTo(
  axios.create({
    baseURL: process.env.REACT_APP_BASE_URL_API,
    headers: {
      "Content-Type": "application/json",
    },
    withCredentials: false,
  })
);

const Api = {
  GET: async (URL: string, params?: object) => {
    const options = {
      params,
    };
    const request = await axiosInstance.get(URL, options);

    return request;
  },
  POST: async (URL: string, data: object): Promise<AxiosResponse<any, any>> => {
    const request = await axiosInstance.post(URL, data);

    return request;
  },
  PUT: async (URL: string, data: object): Promise<AxiosResponse<any, any>> => {
    const request = await axiosInstance.put(URL, data);

    return request;
  },
};

export default Api;
